import { render, staticRenderFns } from "./allocationStorehouseApplyList.vue?vue&type=template&id=6c63ec33&scoped=true"
import script from "./allocationStorehouseApplyList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseApplyList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseApplyList.vue?vue&type=style&index=0&id=6c63ec33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c63ec33",
  null
  
)

export default component.exports